const contractBaseMixin = {
  computed: {
    activeContractName() {
      return this.getContractName();
    }
  },
  methods: {
    getContractName() {
      return this.$route.params.contractName;
    },
    async setActiveContract(contractId, contractName) {
      await this.$store.dispatch("contract/setActiveContract", contractId);

      this.$router.push({
        name: "contract.cabinet.index",
        params: { contractName: contractName }
      });
    },
    getTechnicalDomainByClusterId(clusterId) {
      const envKey = `VUE_APP_K8S_TECHNICAL_DOMAIN_${clusterId}`;
      const domain = process.env[envKey];

      return domain
    }
  }
};


export default contractBaseMixin;